import { QueryObserver } from '@tanstack/react-query';
import { assign, sendParent } from 'xstate';
import { autopayStatusCacheKey, queryFnFactory } from '@syf-api-library/autopay-status';
import fetchMachine from './fetchMachine';
const ASSIGN_ACTION = assign({
    autopayStatusQueryResult: ({ autopayStatusQueryResult }, event) => {
        const [, data] = event.data;
        return Object.assign(Object.assign({}, autopayStatusQueryResult), { data });
    }
});
export const sendAutopayStatusSuccessToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'AFTER_AUTOPAY_FETCH' });
});
const autopayStatus = {
    type: 'parallel',
    states: {
        querySubscription: {
            invoke: {
                src: ({ apiConfig, queryClient }) => {
                    const queryKey = autopayStatusCacheKey(apiConfig.keyProps);
                    const queryObserver = new QueryObserver(queryClient, {
                        queryKey,
                        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
                        enabled: false
                    });
                    const subscribe = (next) => {
                        const unsubscribe = queryObserver.subscribe((event) => {
                            if (event.isLoading === false && event.isSuccess === true) {
                                const data = [queryKey, event.data];
                                next({ type: 'SET_AUTOPAY_STATUS', data });
                            }
                        });
                        return {
                            unsubscribe
                        };
                    };
                    return {
                        subscribe
                    };
                }
            }
        },
        api: {
            initial: 'idle',
            states: {
                idle: {},
                fetching: {
                    invoke: {
                        src: fetchMachine,
                        data: {
                            // initialize fetchMachine with context values
                            cacheKey: ({ apiConfig }) => autopayStatusCacheKey(apiConfig.keyProps),
                            queryClient: ({ queryClient }) => queryClient,
                            queryFn: ({ apiConfig }) => queryFnFactory(apiConfig.config, apiConfig.keyProps)
                        },
                        onDone: {
                            target: 'success',
                            actions: ASSIGN_ACTION
                        },
                        onError: {
                            target: 'error',
                            actions: assign({
                                autopayStatusQueryResult: ({ autopayStatusQueryResult }, event) => {
                                    const [, error] = event.data;
                                    return Object.assign(Object.assign({}, autopayStatusQueryResult), { error });
                                }
                            })
                        }
                    },
                    on: {
                        FETCH_AUTOPAY_STATUS: undefined
                    }
                },
                success: {
                    entry: 'sendAutopayStatusSuccessToParent'
                },
                error: {
                    entry: 'sendErrorToParent'
                }
            }
        }
    },
    on: {
        FETCH_AUTOPAY_STATUS: {
            target: '#apiMachine.autopayStatus.api.fetching',
            actions: ({ apiConfig, queryClient }, { force }) => {
                if (force) {
                    queryClient.invalidateQueries(autopayStatusCacheKey(apiConfig.keyProps));
                }
            }
        },
        SET_AUTOPAY_STATUS: {
            target: '#apiMachine.autopayStatus.api.success',
            actions: ASSIGN_ACTION
        }
    }
};
export default autopayStatus;
